import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mestimate',
  templateUrl: './estimate.component.html',
  styleUrls: ['./estimate.component.scss']
})
export class MestimateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
